export default __webpack_public_path__ + "static/media/fiber.bd6d3854.png";